const yotpoEndpoints = {
  CA: 'ca-loyalty',
  US: 'us-loyalty',
  DE: 'de-loyalty',
  FR: 'de-loyalty',
  AT: 'de-loyalty',
  CH: 'de-loyalty',
}
class HHCustomerRegister extends HTMLElement {
  static properties = {
    firstNameInput: { type: String },
    lastNameInput: { type: String },
    emailInput: {
      type: String,
    },
    passwordInput: { type: String },
    optInValue: { type: Boolean },
    birthdateInput: { type: Object },
    registerFormTranslations: { type: Object },
  }

  constructor() {
    super()
    this.getRegisterFormTranslations()
    const form = this.querySelector('#create_customer')
    this.loyaltyOptInInput = this.querySelector('#RegisterForm-OptIn')
    this.marketingOptInInput = this.querySelector(
      '#RegisterForm-marketingOptIn'
    )

    this.addEventListener('keyup', (event) => {
      this.removeInputError()
    })
    if (form) {
      form.addEventListener('submit', async (event) => {
        const { target } = event

        this.firstNameInput = this.querySelector('#RegisterForm-FirstName')
        this.lastNameInput = this.querySelector('#RegisterForm-LastName')
        this.passwordInput = this.querySelector('#RegisterForm-password')
        this.passwordConfirmationInput = this.querySelector(
          '#RegisterForm-passwordConfirmation'
        )
        this.emailInput = this.querySelector('#RegisterForm-email')
        this.birthdateInput = this.querySelector('#RegisterForm-Birthdate')
        this.optInValue = this.querySelector('#RegisterForm-OptIn').checked
        /* both needed to stop page refreshing */
        event.stopImmediatePropagation()
        event.preventDefault()

        this.removeInputError()
        const hasError = this.hasErrors()
        target?.classList.toggle('has-errors', hasError)
        if (hasError) {
          this.displayErrors()
          return
        }
        if (this.optInValue) {
          // Opt in with Yotpo
          const resp = await this.postOptInRequest()
          if (!resp) {
            return
          }
        }
        // No longer in use, webhook endpoint is being used instead
        // this.saveBirthDate(this.birthdateInput.value, this.emailInput.value)
        this.prepareAccountRedirect()
        this.optimisticallySaveBirthDate(this.birthdateInput.value)
        event.target.submit()
      })
    }
  }

  connectedCallback() {
    this.loyaltyOptInInput?.addEventListener(
      'change',
      this.handleLoyaltyOptInChange.bind(this)
    )

    this.marketingOptInInput?.addEventListener(
      'change',
      this.handlePreventMarketingOptInChange.bind(this)
    )
  }

  disconnectedCallback() {
    this.loyaltyOptInInput?.removeEventListener(
      'change',
      this.handleLoyaltyOptInChange
    )

    this.marketingOptInInput?.removeEventListener(
      'change',
      this.handlePreventMarketingOptInChange
    )
  }

  prepareAccountRedirect() {
    window.sessionStorage.setItem('account-register-redirect', true)
  }

  getRequestCredentials() {
    const apiVersion = '2023-07'

    return {
      adminApiUrl: `https://${window.Shopify.shop}/admin/api/${apiVersion}/graphql.json`,
      apiUrl: `https://${window.Shopify.shop}/api/${apiVersion}/graphql.json`,
      storeFrontAccessToken: window.storefrontToken,
    }
  }

  optimisticallySaveBirthDate(birthDate) {
    window.localStorage.setItem('customer-birth-date', birthDate)
  }

  // No longer in use, webhook endpoint is being used instead
  saveBirthDate(birthDate, email) {
    const credentials = this.getRequestCredentials()
    const serverlessURL = window.serverlessURL
    const shopCountry = window.Shopify.country.toLowerCase()
    const customerUpdateURL = `${serverlessURL}/${shopCountry}/schedule-registration-birthday`
    const headers = new Headers()
    headers.append('Authorization', '4ft3r_R3g15t3r')

    fetch(customerUpdateURL, {
      mode: 'cors',
      method: 'POST',
      headers,
      body: JSON.stringify({
        apiUrl: credentials.apiUrl,
        adminApiUrl: credentials.adminApiUrl,
        namespace: 'hhschleich',
        key: 'date_of_birth',
        value: birthDate,
        email: email,
        afterRegistration: true,
      }),
    })
  }
  async getRegisterFormTranslations() {
    try {
      const elem = this.querySelector('#register-form-translations')
      const elemData = JSON.parse(elem?.textContent)
        .replace(/&quot;/g, '"')
        .replace(/=&gt;/g, ':')
      this.registerFormTranslations = JSON.parse(elemData)
    } catch (err) {
      console.error('Error capturing Register Form Translations')
    }
  }
  async postOptInRequest() {
    try {
      const optInValue = this.optInValue || window.Shopify.country === 'US' ? 'true' : 'false'
      const req = await fetch(
        `${window.serverlessURL}/${yotpoEndpoints[window.Shopify.country]}`,
        {
          method: 'POST',
          mode: 'cors',
          body: JSON.stringify({
            email: this.emailInput.value,
            firstName: this.firstNameInput.value,
            lastName: this.lastNameInput.value,
            optIn: optInValue,
          }),
        }
      )
      const resp = await req.json()
      return true
    } catch (err) {
      console.log({ err })
      return false
    }
  }
  inputErrorSlot(msg) {
    const elem = document.createElement('span')
    elem.classList.add('js-input-error')
    elem.setAttribute('slot', 'error')
    elem.innerHTML = `${msg}`
    return elem
  }
  hasValidEmail() {
    const regex = new RegExp('^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$')
    const check = regex.test(this.emailInput?.value)
    return check
  }
  hasValidBirthdate() {
    const userBirthDate = new Date(this.birthdateInput.value).getFullYear() // Use YYYY-MM-DD format
    const todayYear = new Date().getFullYear() // Always use FullYear!!
    const cutOff18 = new Date() // should be a Date
    cutOff18.setFullYear(todayYear - 18)
    return userBirthDate < cutOff18.getFullYear(todayYear - 18)
  }
  hasValidPassword() {
    const lowerCaseRegex = new RegExp('[a-z]')
    const upperCaseRegex = new RegExp('[A-Z]')
    const digitRegex = new RegExp('[0-9]')
    const specialCharRegex = new RegExp('[^\\w\\s]')

    let matchCriteria = 0

    if (lowerCaseRegex.test(this.passwordInput?.value)) matchCriteria++
    if (upperCaseRegex.test(this.passwordInput?.value)) matchCriteria++
    if (digitRegex.test(this.passwordInput?.value)) matchCriteria++
    if (specialCharRegex.test(this.passwordInput?.value)) matchCriteria++

    return matchCriteria >= 3 && this.passwordInput?.value.length >= 8
  }
  hasErrors() {
    return [
      this.firstNameInput?.value,
      this.lastNameInput?.value,
      this.emailInput?.value,
      this.hasValidEmail(),
      this.passwordInput?.value,
      this.hasValidPassword(),
      this.birthdateInput?.value,
      this.hasValidBirthdate(),
    ].some((v) => !v)
  }
  getErrors(field) {
    return this?.registerFormTranslations?.[field]
  }
  displayErrors() {
    if (!this.firstNameInput.value) {
      this.firstNameInput.parentElement.append(
        this.inputErrorSlot(this.getErrors('first_name_error'))
      )
    }
    if (!this.lastNameInput.value) {
      this.lastNameInput.parentElement.append(
        this.inputErrorSlot(this.getErrors('last_name_error'))
      )
    }
    if (!this.emailInput.value || !this.hasValidEmail()) {
      this.emailInput.parentElement.append(
        this.inputErrorSlot(this.getErrors('email_error'))
      )
    }
    if (!this.passwordInput.value || !this.hasValidPassword()) {
      const errorMessage = this.getErrors('password_error');
      const ul = document.createElement('ul');
      ul.classList.add('js-input-error');
      ul.setAttribute('slot', 'error');

      const parts = errorMessage.split('. ');

      parts.forEach((part) => {
        if (part.trim()) {
          const li = document.createElement('li');
          li.textContent = part.trim();
          ul.appendChild(li);
        }
      });
      this.passwordInput.parentElement.insertAdjacentElement("afterend", ul);
    }
    if (
      !this.passwordConfirmationInput.value ||
      this.passwordInput?.value !== this.passwordConfirmationInput?.value
    ) {
      this.passwordConfirmationInput.parentElement.append(
        this.inputErrorSlot(this.getErrors('password_confirmation_error'))
      )
    }
    if (!this.hasValidBirthdate()) {
      this.birthdateInput.parentElement.append(
        this.inputErrorSlot(this.getErrors('birthdate_error'))
      )
    }
  }
  removeInputError() {
    const form = this.querySelector('form')
    form?.classList.remove('has-errors')

    this.querySelectorAll('.js-input-error').forEach((el) => {
      el.remove()
    })
  }

  handleLoyaltyOptInChange(e) {
    const isLoyaltyOptIn = e.target.checked
    const marketingOptInWrapper = this.marketingOptInInput.closest(
      'hh-checkbox-wrapper'
    )

    if (isLoyaltyOptIn) {
      marketingOptInWrapper.checked = isLoyaltyOptIn
      marketingOptInWrapper.setAttribute('inactive', '')
    } else {
      marketingOptInWrapper.removeAttribute('inactive')
    }
  }

  handlePreventMarketingOptInChange(e) {
    if (this.loyaltyOptInInput.checked) {
      e.preventDefault()
      e.stopPropagation()
    }
  }
}
customElements.define('hh-customer-register', HHCustomerRegister)
